import { white, warning } from "../shared/tokens";

export const grey = {
  50: "#F7F7F8",
  100: "#f0f0f0",
  200: "rgb(232,232,232)",
  300: "rgb(222,222,222)",
  400: "rgb(215,215,215)",
  700: "#676767",
  800: "#363636",
  900: "#9C9C9C",
};

// shadows
export const tableHeadShadow = "0 2px 4px 0 rgba(20,20,65,0.05)";
export const tooltipShadow =
  "0px 1px 3px 0px #0000001F, 0px 1px 1px 0px #00000024, 0px 2px 1px -1px #00000033";
export const tooltipArrowShadow =
  "1px 1px 3px 0px #0000001F, 1px 1px 1px 0px #00000024, 2px 2px 1px -1px #0003";

// backgrounds
export const defaultBackground = grey[50];
export const paperBackground = white;
export const lightBackground = grey[200];
export const lighterBackground = grey[300];
export const lightestBackground = grey[400];
export const tooltipBackground = grey[100];

// text
export const primaryText = grey[800];
export const secondaryText = grey[700];
export const disabledText = grey[900];
export const warningText = warning.dark;

// other
export const codeBackgroundColor = white;
export const codeFlash = "rgba(170,170,170,0.7)";
export const tableBorder = "1px solid rgba(0,0,0,0.13)";
